import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  message,
  Popconfirm,
  Row,
  Table,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  addBlogCategory,
  deleteBlogCategory,
  getBlogCategory,
  updateBlogCategory,
} from "./BlogApi";
import { ExtractDate, ExtractTime } from "../../../utils";
import ComponentTitle from "../../../Common/ComponentTitle";

function AddBlogCategory() {
  const [form] = Form.useForm();
  const [blogCategoryData, setBlogCategoryData] = useState([]);
  const [from, setFrom] = useState("add");
  const [filldata, setFilldata] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [blogCategoryName, setblogCategoryName] = useState("");

  // const handleCategoryNameChange = (e) => {
  //   const inputValue = e.target.value;
  //   form.setFieldsValue({ categorySlug });

  //   setblogCategoryName(inputValue);
  //   setCategorySlug(generateCategorySlug(inputValue));
  // };
  const createBlogCategory = (changedValues) => {
    if (from === "add") {
      const payload = {
        blogCategoryName: changedValues.blogCategoryName,
      };
      addBlogCategory(payload)
        .then((response) => {
          if (response.data.status) {
            message.success({ content: response.data.message });
            form.resetFields();
            FetchBlogCategoryData();
          }
        })
        .catch((error) => console.error(error));
    } else {
      const payload = {
        blogCategoryName: changedValues.blogCategoryName,
      };
      updateBlogCategory(payload, `${filldata.id}`)
        .then((response) => {
          if (response.data.status) {
            message.success({ content: response.data.message });
            form.resetFields();
            setFrom("add");
            FetchBlogCategoryData();
          }
        })
        .catch((error) => console.error(error));
    }
  };

  const FetchBlogCategoryData = () => {
    setIsLoading(true);
    getBlogCategory()
      .then((response) => {
        if (response.data.status) {
          setIsLoading(false);
          setBlogCategoryData(response.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching data", err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    FetchBlogCategoryData();
  }, []);

  useEffect(() => {
    if (from === "edit" && filldata) {
      form.setFieldsValue({
        blogCategoryName: filldata?.blogCategoryName,
      });
    } else {
      form.resetFields();
    }
  }, [from, filldata, form]);

  const DeleteAction = (record) => {
    deleteBlogCategory(record.id)
      .then((response) => {
        if (response.data.status) {
          message.success(response.data.message);
          FetchBlogCategoryData();
        }
      })
      .catch((error) => console.error(error));
  };

  const columns = [
    {
      title: "Category Name",
      dataIndex: "blogCategoryName",
      key: "blogCategoryName",
      className: "custom-header font-poppins text-xs",

      render: (data) => <p>{data}</p>,
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",

      render: (data) => (
        <p>
          {ExtractDate(data)} • {ExtractTime(data)}
        </p>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: "custom-header font-poppins text-xs",

      render: (data, record) => (
        <Button
          size="small"
          onClick={() => {
            setFrom("edit");
            setFilldata(record);
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "custom-header font-poppins text-xs",

      render: (data, record) => (
        <Popconfirm
          title="Are you sure you want to delete this Blog Category?"
          onConfirm={() => DeleteAction(record)}
          okText="Yes"
          cancelText="No"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <div>
        <ComponentTitle title={"Add Blog Category "} />

        <Form
          layout="vertical"
          form={form}
          onFinish={createBlogCategory}
          initialValues={{ blogCategoryName: "" }}
        >
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={12}>
              <Form.Item
                label="Category Name"
                name="blogCategoryName"
                rules={[
                  { required: true, message: "Please enter a Name" },
                  { type: "string", message: "Please enter a valid Name" },
                ]}
              >
                <Input
                  placeholder="Enter category name"
                  className="rounded-md p-2 border-gray-300"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} className="flex items-end">
              <Button
                className="bg-rgbaprimary9 text-white text-sm px-4 py-2 rounded-md transition-all hover:bg-rgbaprimary8 w-full sm:w-auto"
                size="middle"
                htmlType="submit"
              >
                {from === "add"
                  ? "Create Blog Category"
                  : "Update Blog Category"}
              </Button>
            </Col>
          </Row>
        </Form>

        <ComponentTitle title={"Blog Category List "} />

        <div
          style={{ maxHeight: "540px", overflow: "auto" }}
          className="bg-white shadow-md  shadow-[rgba(149, 157, 165, 0.2) 0px 8px 24px]"
        >
          <Table
            columns={columns}
            className="w-screen sm:w-screen custom-table-header"
            dataSource={blogCategoryData}
            pagination={false}
            loading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}

export default AddBlogCategory;
